import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DestroyComponentSubs } from 'app/shared/utility/DestroyComponentSubs';
import { Subscription } from 'rxjs/Subscription';
import { EventList, EventAggregator } from 'app/shared/utility/EventAggregator';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { AppConfig } from 'app/app.config';

//@Component({})
@DestroyComponentSubs()
export class BaseComponent {
  protected eventSubscriptions: Array<Subscription>;
  constructor(private appConfig: AppConfig) {
    this.eventSubscriptions = new Array<Subscription>();
  }
  protected subscribeEvent(event: EventList, callback: ((value: any) => void)) {
    let sub = EventAggregator.get(event).subscribe(callback);

    this.eventSubscriptions.push(sub);
  }
}
